<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { fly } from 'svelte/transition';
import Link from '../../components/Link.svelte';
import uiStore from '../../utils/UIStore';

let uiTexts;

let features = {
  chat: true,
  recherche: true,
  askTheText: true,
  summary: true,
};

//load ui texts from ui Store
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

uiStore.featureStore.subscribe((store) => {
  features = store;
});
</script>

<svelte:head>
  <title>{uiTexts.pageTitles.landing}</title>
</svelte:head>

{#if uiTexts != null}
  <div class="hero-box" in:fly={{ y: -20, duration: 500, delay: 200 }} style="">
    <div style="width: 1100px; margin:auto; display:flex;align-items: center;">
      <div class="intro-text">
        <h2>{uiTexts.welcomeTextTitle}</h2>
        <p>
          {uiTexts.welcomeText}
        </p>
      </div>
      <!--Optionaler Link zu weiteren Informationen-->
      <!--<a href={uiTexts.bannerLink} class="banner textlink" target="_blank">
        {uiTexts.bannerText}
      </a>-->
    </div>
  </div>
{/if}

<main in:fly={{ y: -20, duration: 500, delay: 200 }}>
  <section class="content-width" style="padding:50px 0;">
    <h3 style="padding-left: 10px; text-transform:none">{uiTexts.landingPage.f13AppsHeader}</h3>
    <ul id="f13-features" class="tiles-row">
      {#if features.chat}
        <li class="item">
          <Link to="/chat">
            <div
              class="icon-tile"
              style="background-image: url(/static/app-icon-chat.svg);"
              aria-hidden="true"
            ></div>
            <h4>{uiTexts.landingPage.chat.title}</h4>
            <p>{uiTexts.landingPage.chat.description}</p>
          </Link>
        </li>
      {/if}

      {#if features.recherche}
        <li class="item">
          <Link to="/recherche">
            <div
              class="icon-tile"
              style="background-image: url(/static/app-icon-lupe.svg);"
              aria-hidden="true"
            ></div>
            <h4>{uiTexts.landingPage.research.title}</h4>
            <p>
              {uiTexts.landingPage.research.description}
            </p>
          </Link>
        </li>
      {/if}

      {#if features.askTheText}
        <li class="item">
          <Link to="/fragdentext">
            <div
              class="icon-tile"
              style="background-image: url(/static/app-icon-lupe.svg);"
              aria-hidden="true"
            ></div>
            <h4>{uiTexts.landingPage.askTheText.title}</h4>
            <p>{uiTexts.landingPage.askTheText.description}</p>
          </Link>
        </li>
      {/if}

      {#if features.summary}
        <li class="item">
          <Link to="/zusammenfassung">
            <div
              class="icon-tile"
              style="background-image: url(/static/app-icon-summary.svg);"
              aria-hidden="true"
            ></div>
            <h4>{uiTexts.landingPage.summary.title}</h4>
            <p>{uiTexts.landingPage.summary.description}</p>
          </Link>
        </li>
      {/if}

      {#if features.transcription}
        <li class="item">
          <Link to="/transcription">
            <div
              class="icon-tile"
              style="background-image: url(/static/app-icon-transkript.svg);"
              aria-hidden="true"
            ></div>
            <h4>{uiTexts.landingPage.transcription.title}</h4>
            <p>{uiTexts.landingPage.transcription.description}</p>
          </Link>
        </li>
      {/if}
    </ul>
  </section>
  <section class="grey-bg" style="padding:50px 0">
    <div class="content-width">
      <h3 style="padding-left: 10px; text-transform:none">{uiTexts.landingPage.otherAppsHeader}</h3>

      <ul class="further-links-row">
        <li class="item">
          <a
            href="https://commission.europa.eu/resources-partners/etranslation_de"
            target="_blank"
          >
            <div
              class="icon-tile"
              style="background-image: url(/static/app-icon-translate.png);"
              aria-hidden="true"
            ></div>
            <h4>{uiTexts.landingPage.translation.title}</h4>
            <p>{uiTexts.landingPage.translation.description}</p>
          </a>
        </li>

        <li class="item" style="opacity: 0.5;">
          <div
            class="icon-tile"
            style="background-image: url(/static/app-icon-bildgenerierung.png);"
            aria-hidden="true"
          ></div>
          <h4>{uiTexts.landingPage.imageGeneration.title}</h4>
          <p>{uiTexts.landingPage.imageGeneration.description}</p>
        </li>

      </ul>
    </div>
  </section>
</main>

<style>
  main {
    text-align: left;
    padding: 0 10px 120px;
    margin: 0 auto;
    font-size: 1rem;
  }
  h2 {
    font-size: 1.8rem;
    text-align: left;
  }
  h3 {
    font-size: 1.4rem;
    text-align: left;
    margin-bottom: 12px;
  }
  .banner {
    color: #000;
    font-weight: bold;
    background-color: var(--main-color);
    font-size: 1rem;
    padding: 5px 15px;
    height: fit-content;
    margin-left: 90px;
    text-align: center;
    margin-top: -55px;
  }
  .hero-box {
    padding: 50px 10px;
    background-image: url(/images/lp-grafik.jpg);
    background-color: var(--bg-color);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    margin-top: 90px;
  }
  .intro-text {
    max-width: 680px;
    padding: 24px;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    border-radius: 4px;
    color: #fff;
  }
  .intro-text h2 {
    line-height: normal !important;
  }
  .content-width {
    width: 100%;
    max-width: 1160px;
    margin-left: auto;
    margin-right: auto;
  }
  .grey-bg {
    background-color: var(--bg-color);
  }
  p {
    font-size: 1rem;
  }
  .item {
    display: flex;
    flex-direction: column;
  }
  .tiles-row .item h4 {
    background-repeat: no-repeat;
    background-position: right center;
  }

  /*chevron*/
  /*
background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="11.121" height="19.414" viewBox="0 0 11.121 19.414"><path id="chevron-right" d="M1.414,0,0,1.414,8.294,9.706,0,18l1.414,1.414,9.707-9.708Z" transform="translate(0 0)"/></svg>') ;
*/
  .tiles-row {
    display: flex;
  }
  .tiles-row li {
    flex: 1;
    padding: 8px;
    border: 2px solid #fff;
    position: relative;
  }
  .further-links-row li p,
  .tiles-row li p {
    font-weight: normal;
  }
  .further-links-row li.item,
  .tiles-row li.item {
    text-align: center;
  }
  .tiles-row li:hover {
    border: 2px solid var(--bg-color);
  }
  .tiles-row li:last-child {
    margin-right: 0px;
  }
  .further-links-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    gap: 10px;
  }
  .further-links-row li {
    padding: 12px;
    border: 2px solid var(--bg-color);
  }
  .further-links-row li:hover {
    border: 2px solid #fff;
  }
  .icon-tile {
    background-color: var(--bg-color);
    height: 170px;
    width: 170px;
    margin: 0 auto 16px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    border-radius: 16px;
  }
  .further-links-row li .icon-tile {
    background-color: #fff;
  }
  ul {
    display: flex;
  }

  .new-badge:before {
    content: "NEU";
    background-color: var(--sec-color);
    color: var(--main-color);
    font-size: 0.75rem;
    font-weight: bold;
    padding: 3px 10px 2px;
    border-radius: 1rem;
    position: absolute;
    top: -5px;
    left: calc(50% + 20px);
  }

  @media only screen and (max-width: 1100px) {
    .hero-box {
      background-image: none;
    }
  }
</style>
